import React, { useState, useContext } from 'react'

// Components
import { If } from '../../../../components'
import SettingsForm from './SettingsForm'
import PrequalPrompt from './PrequalPrompt'

// Constants
import { TABS } from '../../../../constants/display'

// Context
import { AppContext } from '../../../../contexts'

// Hooks
import { useShouldRequestPrequal } from '../../../../hooks/buyerSettings'

// Styles
import styles from './SettingsPanel.module.scss'

const SettingsPanel = () => {
  const { execute: updateCanRequestPrequal, value: canRequestPrequal } =
    useShouldRequestPrequal()
  const [showPrequalPrompt, setShowPrequalPrompt] = useState(false)
  const { setActiveTab } = useContext(AppContext)

  const hidePrequal = () => {
    setShowPrequalPrompt(false)
    setActiveTab(TABS.OVERVIEW)
  }

  const showPrequal = () => {
    setShowPrequalPrompt(true)
    updateCanRequestPrequal()
  }

  const afterSubmit = prequalChanged => {
    if (canRequestPrequal && prequalChanged) {
      showPrequal()
    } else {
      setActiveTab(TABS.OVERVIEW)
    }
  }

  return (
    <div className={styles.container}>
      <SettingsForm afterSubmit={afterSubmit} />

      <If condition={showPrequalPrompt}>
        <PrequalPrompt className={styles.prequalPrompt} onClose={hidePrequal} />
      </If>
    </div>
  )
}

SettingsPanel.propTypes = {}

export default SettingsPanel
